import React from "react";
import { HeadLine } from "../modules/HeadLine";
import styled from "@emotion/styled";

const Scroll = styled.div`
  overflow-y: scroll;
  height: ${({ height }) => `${height}px`};
`;
const SpreadsheetInstructions = () => {
  return (
    <div
      className="SpreadsheetInstructions"
      style={{ flex: "80%", padding: "2rem" }}
    >
      <HeadLine
        headingText={"How to Upload a Spreadsheet"}
        tagLine={
          "Want to know how to use an upload feature? Check out this quick tutorial:"
        }
      />

      <Scroll height={window.innerHeight - 200}>
        <div className="SpreadsheetInstructions__section1">
          <h4>1. Create a spreadsheet with the following headers</h4>
          <div className="SpreadsheetInstructions__section1__container">
            <div className="SpreadsheetInstructions__section1__container__left">
              <div>
                <ul>
                  <li>Merchant</li>
                  <li>Number</li>
                  <li>Pin</li>
                  <li>Balance</li>
                  <li>
                    RefID <span>*</span>
                  </li>
                </ul>
              </div>
              <div className="SpreadsheetInstructions__section1__container__right">
                <div>
                  <span>*</span> RefID = Reference Id
                </div>
                <div>
                  This is an optional field that can store your own reference id
                  information. If populated, the Ref Id can be found in the My
                  Accounts ==> Orders view
                </div>
              </div>
            </div>
            <div>
              <img
                alt="step 1 image"
                src="https://s3.amazonaws.com/new-cardcash-images/bulk/Step1_Premier_SpreadsheetUpload.png"
              />
            </div>
          </div>
        </div>
        <div className="SpreadsheetInstructions__section2">
          <img
            alt="step 2 image"
            src="https://s3.amazonaws.com/new-cardcash-images/bulk/Step2_Premier_SpreadsheetUpload.png"
          />
          <h4>
            2. Add gift cards to the spreadsheet with all the information in the
            correct cells.
          </h4>
        </div>
        <div className="SpreadsheetInstructions__section3">
          <h4>3. Save the spreadsheet in one of the following formats:</h4>
          <ul>
            <li>— .csv (Comma separated value)</li>
            <li>— .xlsx (Excel Workbook)</li>
          </ul>
        </div>
        <div className="SpreadsheetInstructions__section4">
          <h4>
            4. Select the Upload Spreadsheet button, select the file you wish to
            upload, and upload.
          </h4>
          <br />
          <img
            alt="step 4 image"
            src="https://s3.amazonaws.com/new-cardcash-images/bulk/uploadSpreadsheet_Image1.png"
          />
        </div>
        <div className="SpreadsheetInstructions__section5">
          <h4>
            5. If errors are present, please correct the errors that are shown
            and select ‘Add to Order.’ If you’d like to remove the card from the
            order, select ‘Remove Card’ and the card will be removed the order.
            If you wish to remove all errors and continue to list the accepted
            inventory, simply select ‘Clear Errors’ to continue with placing the
            order.
          </h4>
          <br />
          <img
            alt="step 5 image"
            src="https://s3.amazonaws.com/new-cardcash-images/bulk/uploadSpreadsheet_Image2.png"
          />
        </div>
        <div className="SpreadsheetInstructions__section6">
          <h4>
            If you continue to experience any technical issues or have any
            concerns, please contact your Account Manager or email
            customersuccess@cardcash.com.
          </h4>
        </div>
      </Scroll>
    </div>
  );
};

SpreadsheetInstructions.propTypes = {};

export default SpreadsheetInstructions;
